<template>
  <tr>
    <td>
      <v-checkbox
        v-model="addr.isprimary"
        :disabled="!addr.active || disabled"
      ></v-checkbox>
    </td>
    <td>
      <v-text-field
        v-if="showEditFacility"
        v-model="addr.facility.name"
        label="Facility Name"
      ></v-text-field>
      <strong v-else>
        {{ addr.facility.name }}
        {{ addr.isprimary ? "(Primary Work Address)" : "" }}
      </strong>
    </td>
    <td>
      <p>
        <span v-if="!showEditFacility">
          Address: <em>{{ addr.facility.address || "not found" }}</em> <br />
          Postcode: <em>{{ addr.facility.postcode || "not found" }}</em> <br />
          HPI: <em>{{ addr.facility.hpifacilityid || "not found" }}</em>
          <a
            v-if="
              (addr.facility.custom || !addr.facility.postcode) && !disabled
            "
            @click="showEditFacility = !showEditFacility"
          >
            <br />
            Edit Facility
          </a>
        </span>
        <span v-else>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="addr.facility.address"
                label="Address"
                dense
                expanded
                hide-details
                :disabled="disabled"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="addr.facility.postcode"
                label="PostCode"
                dense
                hide-details
                length="4"
                :disabled="disabled"
              />
            </v-col>
            <v-col cols="4">
              <v-btn
                small
                color="primary"
                :loading="loading"
                @click="saveFacility"
                :disabled="disabled"
                >Save</v-btn
              ><br />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <a @click="showEditFacility = false">Stop editing facility</a>
            </v-col>
          </v-row>
        </span>
      </p>
    </td>
    <td>
      <em>Updated: {{ addr.updatedat | formatDate }}</em>
      <br />
      {{ addr.active ? "" : `Inactive:` }} {{ addr.inactiveat | formatDate }}
    </td>
    <td>
      <v-btn
        icon
        @click="
          addr.active = false;
          saveAddress();
        "
        :disabled="disabled"
        ><v-icon danger>delete</v-icon></v-btn
      >
    </td>
  </tr>
</template>

<script>
export default {
  name: "WorkAddress",
  data() {
    return {
      addr: {},
      loading: false,
      showEditFacility: false
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    address: {
      type: Object,
      required: false,
      default: () => new Object()
    }
  },
  methods: {
    async saveAddress() {
      this.loading = true;
      try {
        // console.debug("saving address");
        var res = await this.$http.patch("workaddresses", this.addr);
        if (res.data) {
          // console.debug("returned:", res);
          this.addr = { ...res.data };
          this.$emit("change", this.addr);
        }
      } catch (e) {
        this.handleError(e);
      } finally {
        this.loading = false;
      }
    },
    async saveFacility() {
      console.debug("saving facility", this.addr.facility);
      if (!this.addr || !this.addr.facility || !this.addr.facility.id) {
        return;
      }
      try {
        this.loading = true;
        let res = await this.$http.patch("hpifacilities", this.addr.facility);

        this.$emit("change", this.addr);
        this.showEditFacility = false;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    address: {
      immediate: true,
      handler(newVal) {
        this.addr = { ...newVal };
      }
    },
    "addr.isprimary": "saveAddress"
  }
};
</script>
